import { useState, useEffect } from "react";
import {
  deleteAllItems,
  deleteItem,
  unlinkItem,
} from "../../utils/requests/itemRequests";
import useTokenHook from "../context/useTokenHook";
import logger from "../../lib/logger";

const useDeleteItems = (tableData) => {
  const [newData, setNewData] = useState(tableData);
  const { token } = useTokenHook();

  useEffect(() => {
    setNewData(tableData);
  }, [tableData]);

  const deleteAllHook = async (userId, itemIds) => {
    try {
      await deleteAllItems(token, itemIds);
    } catch (error) {
      logger.error(error.message);
      throw error;
    }
  };

  const deleteHook = async (userId, itemId, boardId) => {
    try {
      const response = await deleteItem(token, itemId, boardId);

      if (response.data.error) {
        throw new Error(response.data.error);
      }
    } catch (error) {
      logger.log(error.message);
    }
  };

  const unlinkHook = async (userId, itemId, boardId) => {
    try {
      const response = await unlinkItem(token, itemId, boardId);

      if (response.data.error) {
        throw new Error(response.data.error);
      }
    } catch (error) {
      logger.error(error.message);
    }
  };

  return {
    deleteAllHook,
    deleteHook,
    unlinkHook,
    newData,
    setNewData,
  };
};

export default useDeleteItems;
